import React, { createContext, useReducer, useContext } from "react";

// Create context
export const AppContext = createContext();

// Initial state
const initialState = {
  reportingCohortId: localStorage.getItem('selectedCohortId') || null,
  userCohorts: [],
  currentCohort: null,
  firstName: '',
  lastName: '',
  role: '',
  isInitialized: false
};

// Action types
export const SET_REPORTING_COHORT_ID = 'SET_REPORTING_COHORT_ID';
export const SET_USER_COHORTS = 'SET_USER_COHORTS';
export const SWITCH_COHORT = 'SWITCH_COHORT';
export const SET_INITIALIZED = 'SET_INITIALIZED';

// Reducer
const reducer = (state, action) => {
  switch (action.type) {
    case SET_REPORTING_COHORT_ID:
      return {
        ...state,
        reportingCohortId: action.payload
      };
    case SET_USER_COHORTS:
      // Find the cohort that matches the stored ID, or default to first cohort
      const storedCohortId = localStorage.getItem('selectedCohortId');
      const initialCohort = storedCohortId 
        ? action.payload.find(cohort => cohort.cohortId === storedCohortId) 
        : action.payload[0];
      
      return {
        ...state,
        userCohorts: action.payload,
        currentCohort: initialCohort || null,
        reportingCohortId: initialCohort?.cohortId || null,
        firstName: initialCohort?.firstName || '',
        lastName: initialCohort?.lastName || '',
        role: initialCohort?.role || '',
        isInitialized: true
      };
    case SWITCH_COHORT:
      const newCohort = state.userCohorts.find(cohort => cohort.cohortId === action.payload);
      // Store the selected cohort ID in localStorage
      localStorage.setItem('selectedCohortId', action.payload);
      return {
        ...state,
        currentCohort: newCohort,
        reportingCohortId: action.payload,
        firstName: newCohort?.firstName || '',
        lastName: newCohort?.lastName || '',
        role: newCohort?.role || ''
      };
    case SET_INITIALIZED:
      return {
        ...state,
        isInitialized: action.payload
      };
    default:
      return state;
  }
};

// Provider component
export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
}

// Custom hook for using the context
export function useAppContext() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
}
